import { env } from 'utils/env';

export const analytics = {
	measurementId: env.APP_ANALYTICS_MEASUREMENT_ID,
};
